import ReactGA from 'react-ga';
import  { getEnvironment }  from '../helpers';
const environment = getEnvironment();

export function startTracing(){
    const TRACING_ID = "UA-67813910-4";
    const TRACING_ID_TEST = "UA-67813910-5";
    switch(environment){
        case 'production':
            ReactGA.initialize(TRACING_ID);
            break;
        case 'staging':
            ReactGA.initialize(TRACING_ID_TEST);
            break;
        default:
            ReactGA.initialize(TRACING_ID_TEST);
            break;
    }
} 

export function pageGA(){
    ReactGA.pageview(window.location.pathname);
    return;
}

export function  eventGA(myEvent){
    ReactGA.event(myEvent);
    return;
}

export const CATEGORY_GA ={
    management:{
        efosValidation:{
            category: 'Gestion',
            action: "Entro a validación EFOS"
        }
    },
    sales:{
        purchaseStarted:{
            category: 'Ventas',
            action: "Inició una compra"
        },
        purchaseWasMade:{
            category: 'Ventas',
            action: "Se realizó una compra del sistema"
        }
    },
    session:{
        startSession:{
            category: 'Sesión',
            action: "Inició sesión "
        },
        startSessionWithoutLicense:{
            category: 'Sesión',
            action: "Inició sesión de usuario sin licencia"
        },
        endSession:{
            category: 'Sesión',
            action: "Finalizó sesion"
        }
    },
    downloads:{
        downloadWithoutPdf:{
            category: 'Descargas',
            action: "Solicitó descarga con pdf "
        },
        downloadWithPdf:{
            category: 'Descargas',
            action: "Solicitó descarga sin pdf"
        },
        downloadReporte:{
            category: 'Descargas',
            action: "Realizó una descarga de reporte"
        },
        downloadWithEFOS:{
            category: 'Descargas',
            action: "Solicitó descarga EFOS"
        }
    },
    configuration:{
        loadFiel:{
            category: 'Configuración',
            action: "Terminó la carga de la FIEL"
        },
        monthlyEstimatedRequest:{
            category: 'Configuración',
            action: "Solicitó calcular el estimado mensual"
        },
        deleteFiel:{
            category: 'Configuración',
            action: "Se eliminó un certificado"
        }
    },
    register:{
        endRegistration:{
            category: 'Registro',
            action: "Se realizó el registro "
        }
    }
}